import { Component, Injector, Input, OnInit } from '@angular/core';
import { GridActionHandlerBase } from '../../../../../components/common/grid-base/actions/grid-action-handler-base';
import { LoadDataGridActionHandler } from '../../../../../components/common/grid-base/actions/load-data-grid-action-handler';
import { LoadDataKeepFilterKeepSelectionGridActionHandler } from '../../../../../components/common/grid-base/actions/load-data-keep-filter-keep-selection-grid-action-handler';
import { SearchGridActionHandler } from '../../../../../components/common/grid-base/actions/search-grid-action-handler';
import { UnselectCheckboxesGridActionHandler } from '../../../../../components/common/grid-base/actions/unselect-checkboxes-grid-action-handler';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';

/**
 * Comparables properties workspace
 */
@Component({
  selector: 'comparables-properties-workspace',
  templateUrl: './comparables-properties-workspace.component.html',
  styleUrls: ['./comparables-properties-workspace.component.css']
})
export class ComparablesPropertiesWorkspaceComponent extends WorkspaceBase implements OnInit {
  /**
   * JavaScript Oid property name of BO (in this case Property DTO)
   */
  public oidPropertyName = "Oid";

  /**
   * Show the form
   * @param oid Oid of the item that should be loaded in the form. Use -1 for new mode
   */
  public showForm(oid: number): void {
    this.showGrid = false;
    this.oid = oid;

    this.eventBus.broadcastEvent('searchBarVisibility', false);
  }

  /**
   * The workplace
   */
  private _workplace: any;

  /**
   * Sets the workplace
   */
  @Input() public set workplace(workplace: any) {
    this._workplace = workplace;
  }

  /**
   * Gets the workplace
   */
  public get workplace(): any {
    return this._workplace;
  }

  /**
   * The tab element
   */
  private _tabElement: any;

  /**
   * Sets te tab element
   */
  @Input() public set tabElement(tabElement: any) {
    this._tabElement = tabElement;
  }

  /**
   * Gets the tab element
   */
  public get tabElement(): any {
    return this._tabElement;
  }

  /**
   * Constructor
   * @param injector The Angular injector
   */
  constructor(protected injector: Injector) {
    super(injector);
  }

  /**
   * Called if the grid state was changed. Use this to notify the nav bar or perform similar actions
   * @param gridState The new grid state: true: Grid is shown, so the form isn't showh. False: Grid isn't show, but the form is shown
   */
  protected onShowGridChanged(gridState: boolean): void {
    this.eventBus.broadcastEvent('showGridChanged', { area: 'comparablesProperty', value: gridState });
  }

  /**
   * Gets the action handlers
   */
  protected get actionHandlers(): GridActionHandlerBase[] {
    return [
      new SearchGridActionHandler(this.injector, this, 'comparables.property.search'),
      new LoadDataGridActionHandler(this.injector, this, 'properties.loadData'),
      new LoadDataGridActionHandler(this.injector, this, 'comparables.property.saved'),//event after import
      new LoadDataKeepFilterKeepSelectionGridActionHandler(this.injector, this, 'propertiesDataSaved'),
      new UnselectCheckboxesGridActionHandler(this.injector, this)
    ];
  }

  /**
   * Registers any required events. Please don't forget to unsubscibe!
   */
  protected registerEvents(): void {
    const onEvents = this.onEvents;
    const eventBus = this.eventBus;

    onEvents.push(eventBus.subscribeEvent('comparables.property.showAll', (_payload, _options) => {
      this.grid.showAll(null);
    }));

    onEvents.push(eventBus.subscribeEvent('newPropertyFromNav', (_payload, _options) => {
      this.showGrid = false;
      this.oid = null;
      eventBus.broadcastEvent('createPropertiesData');
      eventBus.broadcastEvent('showSaveCancelNavigationAction', false);
    }));

    onEvents.push(eventBus.subscribeEvent('createPropertiesData', (_payload, _options) => {
      this.showForm(-1);
    }));

    onEvents.push(eventBus.subscribeEvent('deleteObjects', (_payload, _options) => {
      const oids = this.getCheckedItems();
      if (oids.length === 0) {
        eventBus.broadcastEvent("openConfirmDialog", {
          success: () => {
            //nothing
          }
        }, 'noDeleteNothingSelected');
      }
      else {
        const options = {
          type: 'comparablesProperty'
        };

        eventBus.broadcastEvent('deleteComparablesConfirmation', oids, options);
      }
    }));

    onEvents.push(eventBus.subscribeEvent('createLeaseTransactionDataFromProperty', (_payload, _options) => {
      const selectedItem = this.grid.selectedItem;
      eventBus.broadcastEvent('createLeaseTransactionData', selectedItem);
    }));

    onEvents.push(eventBus.subscribeEvent('createSalesTransactionDataFromProperty', (_payload, _options) => {
      const selectedItem = this.grid.selectedItem;
      eventBus.broadcastEvent('createSalesTransactionData', selectedItem);
    }));

    onEvents.push(eventBus.subscribeEvent('newModeComparablesValuationFromProperty', (_payload, _options) => {
      const selectedItem = this.grid.selectedItem;
      eventBus.broadcastEvent('createValuationsData', selectedItem);
    }));

    onEvents.push(eventBus.subscribeEvent('backClickedTrue', (_payload, _options) => { this.showGrid = true; }));

    onEvents.push(eventBus.subscribeEvent('closeCompPropertiesForm', (_payload, _options) => {
      this.showGrid = true;
      this.oid = null;
      this.eventBus.broadcastEvent('showSaveCancelNavigationAction', false);
    }));
  }

  /**
   * Applies a filter if an element was selected in a higher hierarchy area
   * @param _item Item
   * @param _selectedHierarchy Hierarchy where the element was selected
   * @param _tabConfig Tab config
   * @param reset Reset the selection in the current area
   */
  public filter(_item: any, _selectedHierarchy: number, _tabConfig: any, reset: boolean): void {
    //Nothing
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();

    this.workplace.onTabCreated(this);
  }
}
